import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgGalleryArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 53 130"
    fill="none"
    stroke="#fff"
    strokeWidth={3}
    strokeLinecap="round"
    {...props}
  >
    <path d="M16 14.9 37 65l-21 50.1" />
  </svg>
);
const Memo = memo(SvgGalleryArrow);
export default Memo;
